import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import { Title } from '../../../components/presentation/Text'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import Separator from '../../../components/helpers/Separator'

const PageHeader = () => {
  const { t } = useTranslation(['common', 'listLogs'])
  const navigate = useNavigation()

  return (
    <Fragment>
      <Separator weight={12} />
      <FlexGrid justify="space-between" gutter={0.4}>
        <FlexCol>
          <Title size="h2" color={COLORS.dark3} noWrap>
            {t('listLogs:title')}
          </Title>
        </FlexCol>

        <FlexCol flex={1}></FlexCol>
      </FlexGrid>
      <Separator weight={2} />
    </Fragment>
  )
}

export default PageHeader
